import { last, sort } from 'ramda';
import { TMonth, TOptions } from '../../../common/types/options';

export const sortMonths = (a: TMonth, b: TMonth) => {
  if (a.value > b.value) {
    return 1;
  } else {
    return -1;
  }
};

export const findLastMonth = (periods: TOptions[]) => {
  const locMonths = (last(periods) as TOptions).months;

  const months = sort(sortMonths, locMonths);

  return (last(months) as TMonth).value;
};

export const createStateMonthsAndYears = (periods: TOptions[], options: TMonth[]) => {
  const locMonths = (last(periods) as TOptions).months;

  const months = sort(sortMonths, locMonths);

  return {
    monthsThisYear: months,
    year: (last(options) as TMonth).value,
    month: (last(months) as TMonth).value,
  };
};
